import React from "react";

import axios from 'axios';
import { connect } from "react-redux";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'bootstrap-css-only/css/bootstrap.min.css';
// import 'mdbreact/dist/css/mdb.css';
// import { MDBInput } from 'mdb-react-ui-kit';
import { store } from "../../redux/store";
import { selectedRechargableAmnt, selectedRechargableAmnt1, setBeneCustomerId, setCurrenntCircle, setCurrentOpertaor, setDTHCustomerId, setRechargeTxhHistory, setRechargeType, setRechrgeMobile, setShowRecargeSection } from "../../redux/recharge/recharge.action";
import { Link } from "react-router-dom";
import { event } from "jquery";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();

class DTHRecharge extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            message: '',
            planTypeList: [],
            selectedPlan: '',
            amountErrMsg: '',
            mobileErrMsg: '',
            customerIdErrMsg: '',
            customerId: '',
            operatorMsg: '',
            mobile: '',
            amount: '',
            selectedOperator: ''
        }
    }
    enterMobileNumber = (e) => {
        e.preventDefault();

        this.setState({
            mobile: e.target.value
        })
        if (e.target.value.length == 10) {
            this.setState({
                mobileErrMsg: ''
            })
            store.dispatch(setRechrgeMobile(e.target.value));
        }
    }

    selectAirtel = () => {
        this.setState({
            operator: 'AIRTEL_DTH',
            selectedOperator: 'AIRTEL_DTH',
            operatorMsg: ''
        })

        store.dispatch(setCurrentOpertaor('AIRTEL_DTH'));
    }
    selectDishTv = () => {
        this.setState({
            operator: 'DISHTV',
            selectedOperator: 'DISHTV',
            operatorMsg: ''
        })

        store.dispatch(setCurrentOpertaor('DISHTV'));
    }
    selectSunTv = () => {
        this.setState({
            operator: 'BIGTV',
            selectedOperator: 'BIGTV',
            operatorMsg: ''
        })

        store.dispatch(setCurrentOpertaor('BIGTV'));
    }
    selectD2H = () => {
        this.setState({
            operator: 'D2H',
            selectedOperator: 'D2H',
            operatorMsg: ''
        })

        store.dispatch(setCurrentOpertaor('D2H'));
    }

    selectTataSky = () => {
        this.setState({
            operator: 'TATASKY',
            selectedOperator: 'TATASKY',
            operatorMsg: ''
        })

        store.dispatch(setCurrentOpertaor('TATASKY'));
    }
    setSelectedAmount = (value) => {
        this.setState({
            amount: value
        })
    }
    enterAmount = (e) => {
        e.preventDefault();
        this.setState({
            amount: e.target.value
        })
    }

    setSelectedAmount = (value) => {

    }
    enterAmount = (e) => {
        e.preventDefault();

        this.setState({
            amountErrMsg: '',
            amount: e.target.value
        })
    }


    showBrowsePlanDivision = () => {
        store.dispatch(setShowRecargeSection('plans'));
    }

    enterCustomerId = (e) => {
        e.preventDefault();
        this.setState({
            customerIdErrMsg: '',
            customerId: e.target.value
        })

        store.dispatch(setDTHCustomerId(e.target.value));
    }
    proceedtoRecarge = () => {

        var amount = '';
        // this.setState({
        //     amountErrMsg: '',
        //     displayErrorMsg: '',
        //     mobileErrMsg: ''
        // })

        amount = this.state.amount;

        if (amount != '' && this.state.mobile != '' && this.state.mobile.length == 10
            && this.state.customerId != ''
            && this.state.selectedOperator != '') {
            store.dispatch(selectedRechargableAmnt1(amount));
            store.dispatch(setRechargeType('dth'));
            setTimeout(() => {
                var rechargeMoneyTransfer = document.getElementById('rechargeMoneyTransfer');
                rechargeMoneyTransfer.click();
            }, 200);

        } else {

            if (this.state.amount == '') {
                this.errorMessageCall('Please enter an amount to proceed', 'amount')
            }
            if (this.state.mobile == '' || this.state.mobile.length < 10) {
                this.errorMessageCall('Please enter valid Mobile No', 'mobile')
            }
            if (this.state.customerId == '') {
                this.errorMessageCall('Please enter customer Id', 'customerId')
            }
            if (this.state.selectedOperator == '') {
                this.errorMessageCall('Please select Operator', 'operator')
            }

        }


    }
    componentDidMount() {
        this.setState({
            displayErrorMsg: '',
            amountErrMsg: '',
            mobileErrMsg: '',
            customerIdErrMsg: '',
            operatorMsg: ''
        })

        store.dispatch(setCurrentOpertaor(''));
        store.dispatch(setRechrgeMobile(''));
        store.dispatch(setDTHCustomerId(''));
        store.dispatch(setRechargeTxhHistory(''));
        this.loadTxnHistory();
    }
    componentWillUnmount() {
    }


    errorMessageCall = (message, type) => {
        if (type == 'amount') {
            this.setState({
                amountErrMsg: message
            })
        }
        if (type == 'mobile') {
            this.setState({
                mobileErrMsg: message
            })
        }
        if (type == 'customerId') {
            this.setState({
                customerIdErrMsg: message
            })
        }
        if (type == 'operator') {
            this.setState({
                operatorMsg: message
            })
        }
    }

    loadTxnHistory() {
        var url = '';
        store.dispatch(setRechargeTxhHistory('loading'));

        url = '/api/v1/dth/order/history';

        var d = new Date();
        d.setDate(d.getDate() - 2);
        var startDate = d.toISOString().slice(0, 10);
        var d1 = new Date();
        d1.setDate(d1.getDate() + 1);
        var endDate = d1.toISOString().slice(0, 10);
        console.log('to date..' + endDate);
        console.log('start date' + startDate);


        var header = {
            msgType: "ORDER_HISTORY",
            service: 'DTH',
            src: "recharge",
            dst: "recharge",
            channel: "API",
            requesterId: this.props.clientRequesterId,
            requestId: uuidv4(),
            traceId: uuidv4(),
        }
        var request = {
            header: header,
            device: this.props.deviceInfo,
            agentId: this.props.agentInfo.id,
            pageNo: 0,
            startDate: startDate,
            endDate: endDate

        }

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        console.log('txn history req:' + JSON.stringify(request));

        httpClient.post(url, request, {
            timeout: 60 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {


            console.log(' response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'SUCCESS') {
                store.dispatch(setRechargeType('dth'));
                store.dispatch(setRechargeTxhHistory(response.data.orders));

            } else {
                store.dispatch(setRechargeTxhHistory('error'));
            }
        }).catch(error => {
            store.dispatch(setRechargeTxhHistory('error'));
            // if(error.message.includes("401")){
			// 	tokenErrorHandler.tokenErrorHandle(error.message,this.props.callBackUrl)
			// }else{
				
			// }
        })
    }

    render() {

        return (
            <div class="rechargebox" id="dthform">
                <Link to='/recharge-money-transfer'>
                    <button id='rechargeMoneyTransfer' hidden={true}></button>
                </Link>

                <div class="form-floating mb-3 mt-3">
                    <input type="number" id="mdn" class="form-control" maxlength="10"
                        onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                        onChange={this.enterMobileNumber} required
                        placeholder="Enter mobile" name="mobile">
                    </input>
                    <label for="mdn">Mobile</label>
                    <div class='valid-error'>
                        {this.state.mobileErrMsg}
                    </div>

                </div>





                <div class="operator">
                    <label>Operator</label>
                    <ul>
                        <li class={this.state.selectedOperator == 'AIRTEL_DTH' && 'active'} ><img src="images/airtel.png" alt="Airtel" data-toggle="tooltip" title="Airtel" onClick={this.selectAirtel} /></li>
                        <li class={this.state.selectedOperator == 'DISHTV' && 'active'}><img src="images/dishtv.png" alt="TV" data-toggle="tooltip" title="DishTV" onClick={this.selectDishTv} /></li>
                        <li class={this.state.selectedOperator == 'BIGTV' && 'active'}><img src="images/sun.png" alt="Sun" data-toggle="tooltip" title="Sun" onClick={this.selectSunTv} /></li>
                        <li class={this.state.selectedOperator == 'TATASKY' && 'active'}><img src="images/tata.png" alt="Tata" data-toggle="tooltip" title="TataSky" onClick={this.selectTataSky} /></li>
                        <li class={this.state.selectedOperator == 'D2H' && 'active'}><img src="images/d2h.png" alt="D2H" data-toggle="tooltip" title="D2H" onClick={this.selectD2H} /></li>
                    </ul>
                    <div class='valid-error'>
                        {this.state.operatorMsg}
                    </div>
                </div>

                <div class="form-floating mb-3 mt-3">
                    <input type="text" id="cid" class="form-control" maxlength="11"
                        placeholder="Enter CustomerId" name="customerId"
                        onChange={this.enterCustomerId} />
                    <label for="cid">Customer ID</label>
                    <div class='valid-error'>
                        {this.state.customerIdErrMsg}
                    </div>
                </div>

                {/* <div class="form-floating mb-3 mt-3">
                    <input type="text" id="damt" class="form-control amntxt" maxlength="5" />
                    <label for="damt">Amount</label>
                    <div class="pbtn"><button type="button" id="dthplans">Browse Plans</button></div>
                </div> */}
                <div class="form-floating mb-3 mt-3">
                    <input type="number" id="amt" class="form-control amntxt" maxlength="5"
                        onInput={(e) => e.target.value = e.target.value.slice(0, 5)}
                        onChange={this.enterAmount} required
                        value={this.state.amount}
                        placeholder="Enter amount" name="amount"
                    ></input>
                    <label for="amt">Amount</label>
                    <div class='valid-error'>
                        {this.state.amountErrMsg}
                    </div>
                </div>

                <button type="button" class="btn btn-primary" id="mobilecharge"
                    onClick={this.proceedtoRecarge}>Proceed</button>

            </div>




        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, agentInfo, token,clientRole,clientRequesterId ,callBackUrl} }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token,clientRole,clientRequesterId,callBackUrl
});

export default connect(mapStateToProps, null)(DTHRecharge);
